var path = 'areas/projects/groups/ProjectGroupCreate.html';
var html = "<script octo-section=breadcrumbs type=text/ng-template> <li><a href='#/projectgroups/new'>Create New</a></li> </script> <script octo-section=tools type=text/ng-template> </script> <div class=row> <div class=\"col-sm-12 col-md-12 col-lg-12\"> <help-button></help-button> <h3>Create a project group</h3> <loading-wrapper busy=isLoading> <div class=\"form-box form-horizontal\"> <project-group-editor></project-group-editor> </div> </loading-wrapper> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/groups/ProjectGroupCreate.html
// module id = 8698109454543532
// module chunks = 1